import { TrackJS } from 'trackjs';

import { WlWindow } from '../../typings/globals/cordova';

declare const window: WlWindow;

class Logger {
  static error = (message, ...rest) => {
    const composedMessage = `${message} ${
      rest.length > 0 ? `[${JSON.stringify(rest)}]` : ''
    }`;
    TrackJS.track(composedMessage);

    if (window.location.hostname !== 'www.withlocals.com') {
      console.error(composedMessage);
    }
  };
}

export default Logger;
